import { types } from 'mobx-state-tree'

import TrafficCourt from './TrafficCourt'

const TrafficCounty = types
  .model('TrafficCounty', {
    objectId: types.identifier,
    name: types.maybeNull(types.string),
    stateShortName: types.maybeNull(types.string),
    available: types.maybeNull(types.boolean),
    prospect: types.maybeNull(types.boolean),
    // trafficCourts: types.array(types.late(() => TrafficCourt))
    trafficCourts: types.array(types.late(() => types.reference(TrafficCourt)))
  })
  .preProcessSnapshot(snapshot => {
    if (!snapshot) return {}
    // this function will run on a snapshot to format it before submitting it to the store.
    const parsedSnapshot = {}
    const keys = Object.keys(snapshot)
    keys.forEach(key => {
      const input = snapshot[key]
      switch (key) {
        case 'trafficCourts':
          parsedSnapshot[key] = []
          if (input && input.length && input[0].objectId) {
            parsedSnapshot[key] = input.map(court => court.objectId)
          } else if (input && input.length) {
            parsedSnapshot[key] = input
          }
          break
        default:
          parsedSnapshot[key] = input
          break
      }
    })

    return parsedSnapshot
  })

export default TrafficCounty
